/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import { ApprovalReason } from '@linc-technologies/linced-common/enums/suspensions';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

// Proto: attendance.ApprovalRequest.
export default class ApprovalRequest extends Fragment {
  declare [Type]: 'wellbeing/approval-request';

  // reason is an enum value that specifies why the request was necessary
  @attr('number', { defaultValue: 0 })
  declare reason: number;

  // approved is whether the request has been approved
  @attr('boolean', { defaultValue: false })
  declare approved: boolean;

  // declined is whether the request was declined
  @attr('boolean', { defaultValue: false })
  declare declined: boolean;

  // date is a UNIX timestamp to store when the request was approved/declined
  @attr('number')
  declare date: number | undefined;

  // notes stores any additional information on the approval
  @attr('string', { defaultValue: '' })
  declare notes: string;

  @computed('reason')
  get displayReason() {
    return findBy(ApprovalReason.values, 'value', this.reason)!.label;
  }
}
